import { FC } from 'react';
import { Container } from '@components/atoms/Container';
import { Anchor, AnchorMode } from '@components/atoms/Anchor';
import { RoundIcon, RoundIconVariants } from '@components/atoms/RoundIcon';
import { useThemes } from '@hooks/useThemes';
import { useData } from '@hooks/useData';
import { useCustomNavigate } from '@hooks/useCustomNavigate';
import { SITE_URLS } from '@constants';
import logoSite from '@assets/images/logos/logo-site.svg';
import styles from './SideMenu.module.css';

export interface SideMenuProps {
    menuRef?: (node: HTMLDivElement | null) => void;
    onClose: () => void;
}

export const SideMenu: FC<SideMenuProps> = ({ menuRef, onClose }) => {
    const { useGrayscaleTheme } = useThemes();
    const { allSettings } = useData();
    const { navigate } = useCustomNavigate();

    const handleNavigate = (url: string) => {
        navigate(url);
    };

    const data = allSettings?.data;
    const logoItem = data?.layouts?.find((item) => item.name === 'logo');
    const logoSrc = logoItem?.value || logoSite;

    const socialNetworks = data?.social_networks || [];

    return (
        <div
            ref={menuRef || undefined}
            id={styles['collapseSideMenu']}
            className={`${useGrayscaleTheme ? styles['theme-grayscale'] : ''} collapse collapse-horizontal`}
            style={{ top: 0 }}
            data-testid="collapseSideMenu">
            <div className={styles.background} onClick={onClose}></div>
            <div className={styles.content}>
                <div className={styles['sidebar-header']}>
                    <Container classes='d-flex justify-content-between align-items-center px-4'>
                        <>
                            {logoSrc && (
                                <Anchor href={SITE_URLS.home} mode={AnchorMode.none}>
                                    <img className={styles['sidebar-logo']} src={logoSrc} alt="" />
                                </Anchor>
                            )}
                            <button className={styles['sidebar-close-button']} type="button" onClick={onClose} aria-label="Fechar menu">
                                <i className="fa-light fa-xmark" />
                            </button>
                        </>
                    </Container>
                </div>

                <nav className={styles.menu} aria-label="Menu principal lateral">
                    <button type="button" className={styles['menu-item']} onClick={() => handleNavigate(`/${SITE_URLS.home}`)}>
                        Directório
                    </button>
                    <button type="button" className={styles['menu-item']} onClick={() => handleNavigate(`/${SITE_URLS.home}`)}>
                        Mapa interativo
                    </button>
                    <button type="button" className={styles['menu-item']} onClick={() => handleNavigate(`/${SITE_URLS.spaces}`)}>
                        Imóveis Disponíveis
                    </button>
                    <button type="button" className={styles['menu-item']} onClick={() => handleNavigate(`/${SITE_URLS.contacts}`)}>
                        Contactos
                    </button>
                </nav>

                {socialNetworks.length > 0 && (
                    <div className={styles['social-media']}>
                        <ul className="nav d-inline-flex justify-content-center">
                            {socialNetworks.map((socialNetwork, index) =>
                                socialNetwork.url ? (
                                    <li
                                        key={`side-menu-social-${index}`}
                                        className="nav-item px-2">
                                        <Anchor
                                            href={socialNetwork.url}
                                            mode={AnchorMode.none}
                                            target="_blank"
                                            rel="noopener noreferrer">
                                            <RoundIcon
                                                icon={socialNetwork.icon}
                                                variant={RoundIconVariants.variant1}
                                            />
                                        </Anchor>
                                    </li>
                                ) : null,
                            )}
                        </ul>
                    </div>
                )}
            </div>
        </div>
    );
}
